import React from 'react';
import { useMessages, usePaths } from "react-chatbotify";
import { FaTable } from 'react-icons/fa';
import { LOCAL_UPDATE_TABLE, MD_CAT_BLACK, MD_CAT_YELLOW } from '../constants';
import { setActionPayload, tableState } from '../state';

// Rendered at the end of a recheck bot reply. Pushes the rechecked capability into
// the epic table through the same "action" flow used by the table buttons.
export const UpdateTableButton = ({ capability }: { capability: string }) => {
  const { injectMessage } = useMessages();
  const { goToPath } = usePaths();
  const [clicked, setClicked] = React.useState(false);

  const handleClick = async () => {
    if (clicked) return;
    setClicked(true);
    tableState.showUpdateTableButton = false;
    setActionPayload(LOCAL_UPDATE_TABLE);
    await injectMessage(`Add "${capability}" to the epic coverage table`, "USER");
    await goToPath("action");
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '8px', marginLeft: '20px' }}>
      <button
        onClick={handleClick}
        disabled={clicked}
        title="Add this capability to the table"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 16px',
          borderRadius: '22px',
          border: `1.5px solid ${MD_CAT_BLACK}`,
          background: clicked ? '#f0f0f0' : MD_CAT_YELLOW,
          color: MD_CAT_BLACK,
          fontWeight: 600,
          fontSize: '13px',
          cursor: clicked ? 'default' : 'pointer',
          opacity: clicked ? 0.6 : 1,
        }}
      >
        <FaTable />
        {clicked ? 'Added to table' : 'Add to table'}
      </button>
    </div>
  );
};
